<template>
  <main
    :class="{
      'main-content-area': true,
      'custom-background-image': $root.color_schema.site_bg_img,
    }"
    :style="{
      '--bg-image': `url(${$root.color_schema.site_bg_img}) repeat`,
      '--bg-color': $root.color_schema.site_bg_color,
    }"
  >
    <a
      class="main-tag cas-link"
      :href="getGoLink($root.goto_link, $root.slug)"
      v-if="$root.color_schema.site_bg_img"
      target="_blank"
      :rel="$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'"
    ></a>
    <div
      :class="{
        'custom-background-color': $root.color_schema.site_bg_img,
        'pb-25 pt-26': true,
      }"
      v-observer="mutationObserve"
    >
      <!-- Game banner section -->
      <section class="ct-article">
        <div class="container overflow-auto">
          <!--Breadcrumps-->
          <div class="col-md-12">
            <Breadcrumb :breadcrumbData="articleData.breadcrumb" :dark="true" />
          </div>
          <!--End Breadcrumps-->
        </div>
      </section>
      <!-- End Game banner section -->
      <!-- Horizontal Cards -->
      <template v-for="(data, index) in blockData">
        <CustomComponent :key="`${data.blockName}-${index}`"
            :blockData="data"
            :recommendSection="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? recommend_section : {}"
            :bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
            :blockIndex="index"
            />
      </template>
      <!-- Horizontal Cards ends -->
      <!--Related Page Links-->
      <template
        v-if="
          morePaymentBottom &&
          blockData.length === articleData.content.blocks.length
        "
      >
        <RelatedLinks :relatedLinkData="morePaymentBottom" />
      </template>
      <!--End Related Page Links-->

      <!--Author Block-->
      <template
        v-if="
          auhtorBlockdata &&
          blockData.length === articleData.content.blocks.length
        "
      >
      </template>
      <!--End Author Block-->
    </div>
  </main>
</template>

<script>
import CustomComponent from '@/components/CustomComponent';
import Breadcrumb from "@/components/layouts/Breadcrumb";
import RelatedLinks from "@/components/custom-block/RelatedLinks";
import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";
import { metaChanger } from "@/misc/meta-changer";

export default {
  name: "Article",
  props: ["articleData"],
  data() {
    return {
      helpful: null,
      top_block: {
        type: Object,
        default: () => {},
      },
      assets_images: {
        type: Object,
        default: () => {},
      },
      morePaymentBottom: {
        type: Object,
        default: () => {},
      },
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      top_casino_title: "",
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      bluebar: {},
    };
  },
  components: {
    Breadcrumb,
    CustomComponent,
    RelatedLinks,
  },
  created: function () {
    if (
      this.$root.routes_meta[this.$route.params.postSlug] &&
      this.$root.routes_meta[this.$route.params.postSlug].metaTags
    )
      this.metaChanger(
        this.$root.routes_meta[this.$route.params.postSlug].metaTags
      );

    // Schema Append
    document.getElementById("schema-script").innerHTML =
      this.articleData.schema;

    // Blocks Filtered
    let title = this.articleData.content.blocks.filter((ele) => {
      if (ele.blockName === "core/heading") {
        return ele.filtered_content;
      }
    });
    let content = this.articleData.content.blocks.filter((ele) => {
      if (ele.blockName === "core/paragraph") {
        return ele.filtered_content;
      }
    });
    let emoji_section = this.articleData.content.blocks.filter((ele) => {
      if (ele.blockName === "core/html") {
        return ele.filtered_content;
      }
    });
    this.top_block = { title, content, emoji_section };

    // More Payments Bottom Card
    this.morePaymentBottom = this.articleData.meta.more_payment_method;

    // Author Blocks Filtered
    let atBlock = this.articleData.content.blocks.filter((ele) => {
      if (ele.blockName === "wpvcb/author-block") {
        return ele.filtered_content;
      }
    });
    if (atBlock.length > 0)
      this.auhtorBlockdata = atBlock.shift().filtered_content;

    // RightContent Blocks Filtered
    let rightBlock = this.articleData.content.blocks.filter((ele) => {
      if (ele.blockName === "wpvcb/right-content-simpletoc") {
        return ele.filtered_content;
      }
    });
    if (rightBlock.length > 0)
      this.rightBlockdata = rightBlock.shift().filtered_content;

    // Adminbar Data
    this.$root.adminBarData =
      Object.keys(this.articleData.toolbar).length > 0
        ? this.articleData.toolbar
        : "";
    this.$root.disable = this.$root.adminBarData
      ? this.$root.adminBarData.visible
      : false;

    // Assets Sizes
    this.assets_images =
      Object.keys(this.$root.asset_sizes).length > 0
        ? this.$root.asset_sizes
        : "";
  },
  mounted: function () {
    // if (this.$root.enable_lazyload) {
    //   this.incrementBlockDataValue();
    //   this.$root.show_footer = false;
    // } else {
    this.blockData = this.articleData.content.blocks;
    this.$root.show_footer = true;
    //}

    if (
      this.scriptFlag === 0 &&
      this.articleData.content.blocks.filter((ele) => {
        return (
          ele.blockName === "wpvcb/custom-youtube" ||
          ele.blockName === "wpvcb/youtube-film-strip"
        );
      }).length > 0
    ) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(() => this.heightCheck());
    var that = this;
    window.addEventListener("scroll", () => {
      that.heightCheck();
    });
    window.addEventListener("resize", () => {
      that.heightCheck();
    });
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", () => {
      that.heightCheck();
    });
    window.removeEventListener("resize", () => {
      that.heightCheck();
    });
  },
  methods: {
    pSBC,
    getContrastYIQ,
    getOffset,
    metaChanger,
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function (mutations) {
      if (this.blockData.length < this.articleData.content.blocks.length) {
        let mainContentArea =
          this.getOffset(mutations[0].target).top +
          mutations[0].target.offsetHeight;
        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function () {
      if (this.blockData.length < this.articleData.content.blocks.length) {
        this.busy = true;
        this.incrementBlockDataValue();
        //this.heightCheck();
        this.busy = false;
      }
    },
    incrementBlockDataValue: function () {
      this.blockData = this.articleData.content.blocks.slice(
        0,
        this.blockDataIndex + 1
      );
      this.blockDataIndex++;
    },
    itemFAQ: function (data) {
      let FAQitems = [];
      data.forEach((ele) => {
        let { id, faq_question: title, faq_answer: content } = ele;

        let is_active = false;
        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({ id, title, content, is_active });
      });
      return FAQitems;
    },
  },
  watch: {
    blockData: function () {
      if (this.blockData.length === this.articleData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.pt-37 {
  padding-top: 37px;
}

.hide-mob {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
}

.casino-header {
  display: table;
  width: 100%;
  background: @darkblue;
  .border-radius(12px);
  h2 {
    text-align: center;
    color: @white;
    font-weight: bold;
    padding: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Article.vue